<template>
  <div class="login-container">
    <div class="login-card">
      <h1>Budget Buddy</h1>
      <p class="subtitle">Categorize your retail purchases for better budgeting</p>

      <div v-if="error" class="error-message">
        {{ error }}
      </div>

      <button @click="handleLogin" :disabled="loading" class="btn-login">
        <span v-if="loading">Logging in...</span>
        <span v-else>Sign in with Google</span>
      </button>

      <div class="features">
        <h3>Features:</h3>
        <ul>
          <li>Automatically scan Gmail for retailer receipts</li>
          <li>AI-powered itemization using Google Gemini</li>
          <li>Smart categorization suggestions</li>
          <li>Sync with Monarch Money</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useAuthStore } from '../store/auth'

const authStore = useAuthStore()
const loading = ref(false)
const error = ref(null)

const handleLogin = async () => {
  try {
    loading.value = true
    error.value = null
    await authStore.login()
  } catch (err) {
    error.value = err.message || 'Login failed'
    loading.value = false
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.login-card {
  background: white;
  border-radius: 8px;
  padding: 3rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  width: 100%;
  text-align: center;
}

h1 {
  font-size: 2rem;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.subtitle {
  color: #7f8c8d;
  margin-bottom: 2rem;
}

.error-message {
  background-color: #fee;
  color: #c33;
  padding: 0.75rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.btn-login {
  width: 100%;
  padding: 1rem;
  font-size: 1rem;
  font-weight: 600;
  background-color: #4285f4;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-login:hover:not(:disabled) {
  background-color: #357ae8;
}

.btn-login:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.features {
  margin-top: 2rem;
  text-align: left;
}

.features h3 {
  color: #2c3e50;
  margin-bottom: 1rem;
}

.features ul {
  list-style: none;
  padding: 0;
}

.features li {
  padding: 0.5rem 0;
  color: #555;
}

.features li:before {
  content: "✓ ";
  color: #27ae60;
  font-weight: bold;
  margin-right: 0.5rem;
}
</style>
